import i18n from "../../../plugins/i18n";
const language = localStorage.getItem("language")
i18n.locale = language ? language : "pt-br"
export default{
    outputChatMessages:[
        {

            text: [
                i18n.t("store.outputChatMessages[0]"),
                i18n.t("store.outputChatMessages[1]"),
                i18n.t("store.outputChatMessages[2]"),
                i18n.t("store.rulesVideoUrl")
            ]
        },
        {
            text: [
                i18n.t("store.outputChatMessages[3]")
            ]
        },
        {
            text: [
                i18n.t("store.outputChatMessages[4]"),
                i18n.t("store.outputChatMessages[5]"),
            ]
        },
    ],
    outputChatMessagesIndex: 0,
    messagesView : []
}
